import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.AccountTypeEnumSortEnum>
) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
  } = params;

  const {
    accountTypeEnumList: { items: data, total },
  } = await sdk.getListAccountTypeEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage,
    },
    sort: [{ field, order }],
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { accountTypeEnum: data } = await sdk.getOneAccountTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { accountTypeEnumMany: data } = await sdk.getManyAccountTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const accountTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
});
